import { NihoDividerLight } from "./MaoriElements";
import { Facebook, Instagram, Linkedin, Globe, Mail } from "lucide-react";

const TIINA_TOHU = "/tiina-logo-transparent.png";

const socialLinks = [
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/tiina.co.nz", testId: "social-facebook" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/tiina.co.nz", testId: "social-instagram" },
  { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/company/tiina", testId: "social-linkedin" },
  { icon: Globe, label: "Website", href: "https://www.tiina.co.nz", testId: "social-website" },
  { icon: Mail, label: "Email", href: "mailto:Info@tiina.co.nz", testId: "social-email" },
];

const closingRemarks = [
  "Malo aupito.",
  "Fa'afetai tele lava.",
  "Nga mihi nui.",
  "Vinaka vakalevu.",
  "Fakaue lahi.",
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-[#0E0D0C] overflow-hidden">
      {/* Māori niho border */}
      <NihoDividerLight />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                <img
                  src={TIINA_TOHU}
                  alt="T.I.I.N.A."
                  data-testid="footer-tohu"
                  className="w-11 h-11 object-contain"
                />
              </div>
              <span className="font-['Syne'] text-2xl font-extrabold text-white tracking-tight">T.I.I.N.A.</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              Te Pūtahitanga Auaha Taketake. Five Directors. Five Regions. One Kaupapa.
            </p>
            <p className="text-white/70 text-sm mb-1">
              <a href="https://www.tiina.co.nz" className="hover:text-[#bb321a] transition-colors" data-testid="footer-domain">www.tiina.co.nz</a>
            </p>
            <p className="text-white/70 text-sm mb-6">
              <a href="mailto:Info@tiina.co.nz" className="hover:text-[#bb321a] transition-colors" data-testid="footer-email">Info@tiina.co.nz</a>
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    data-testid={social.testId}
                    aria-label={social.label}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center border border-white/15 text-white/70 hover:text-[#bb321a] hover:border-[#bb321a]/40 transition-all duration-200"
                  >
                    <Icon className="w-4 h-4" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-6">
              Navigate
            </h4>
            <div className="space-y-3">
              {[
                { label: "About", id: "about" },
                { label: "People", id: "people" },
                { label: "Place", id: "place" },
                { label: "Planet", id: "planet" },
                { label: "Membership", id: "membership" },
                { label: "Contact", id: "contact" },
              ].map((link) => (
                  <a
                    key={link.id}
                    href={`#${link.id}`}
                    data-testid={`footer-link-${link.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      document
                        .querySelector(`#${link.id}`)
                        ?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="block text-sm text-white/70 hover:text-[#bb321a] transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                )
              )}
            </div>
          </div>

          {/* Closing remarks */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-6">
              With Gratitude
            </h4>
            <div className="space-y-2">
              {closingRemarks.map((remark) => (
                <p
                  key={remark}
                  className="text-sm text-white/70 italic font-light"
                >
                  {remark}
                </p>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">
            T.I.I.N.A. - The Indigenous Innovation Network Agency
          </p>
          <div className="flex items-center gap-4">
            <a href="/auth?type=staff" className="text-xs text-white/20 hover:text-white/50 transition-colors" data-testid="footer-staff-link">Staff</a>
            <p className="text-xs text-white/30">
              We do not adapt who we are to fit the room. We change the room.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
